import React, { useMemo, useState } from 'react'
import styles from './table.module.scss'
import getVectorImage from '../../utils/getVectorImage'
import TextBox from '../TextBox'
import LoadingState from '../Loader'

const Table = ({ rows, cols, processed }) => {
  const [query, setQuery] = useState('')
  const [sortConfig, setSortConfig] = useState(null)

  const sortedData = useMemo(() => {
    let sortableData = [...rows]
    if (sortConfig) {
      sortableData.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? -1 : 1
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? 1 : -1
        }
        return 0
      })
    }
    return sortableData
  }, [rows, sortConfig])

  const handleSearchChange = (e) => {
    setQuery(e.target.value)
  }

  const filteredData = useMemo(() => {
    return sortedData.filter((item) =>
      cols.some((column) =>
        item[column.accessor]
          ?.toString()
          .toLowerCase()
          .includes(query.toLowerCase())
      )
    )
  }, [query, sortedData, cols])

  const visibleColumns = useMemo(() => {
    return cols.filter((col) => !col.hidden)
  }, [cols])

  const requestSort = (key) => {
    let direction = 'asc'
    if (sortConfig && sortConfig.key === key) {
      if (sortConfig.direction === 'asc') {
        direction = 'desc'
      } else if (sortConfig.direction === 'desc') {
        direction = 'init' // Reset to initial state
      }
    }
    setSortConfig(direction === 'init' ? null : { key, direction })
  }

  const getClassNamesFor = (name) => {
    if (!sortConfig) {
      return 'init'
    }
    return sortConfig.key === name ? sortConfig.direction : 'init'
  }

  return (
    <div className={styles.table_container} disabled={true}>
      <TextBox
        className={styles.search}
        placeholder="Search "
        value={query}
        onChange={handleSearchChange}
      />

      <table className={styles.table}>
        <thead>
          <tr>
            {visibleColumns.map((col) => {
              return (
                <th key={col.id} onClick={() => requestSort(col.accessor)}>
                  {col.label}{' '}
                  <span className={styles.arrow}>
                    {getClassNamesFor(col.accessor) === 'init' ? (
                      <span className={styles.hidden}>
                        {getVectorImage('up')}
                      </span>
                    ) : getClassNamesFor(col.accessor) === 'asc' ? (
                      getVectorImage('up')
                    ) : (
                      getVectorImage('down')
                    )}
                  </span>
                </th>
              )
            })}
          </tr>
        </thead>
        <tbody>
          {filteredData.map((row, idx) => {
            return (
              <tr>
                {visibleColumns.map((col) => {
                  return (
                    <td>
                      {col.render
                        ? col.render(row[col.accessor], row)
                        : row[col.accessor]}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default Table
